import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorComponent } from './paginator.component';
import { SelectModule } from '../select/select.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [
    PaginatorComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    SelectModule,
    IconModule
  ],
  exports: [
    PaginatorComponent
  ]
})
export class PaginatorModule { }
